import classNames from 'classnames';

import { Link } from '@components/Link';
import { SanityImage } from '@components/SanityImage';
import { Svg } from '@components/Svg';

import { CmsListWithImage } from '@interfaces/common';
import { breakpoints } from '@utils/device';

import styles from './ListWithImage.module.css';

export type ListWithImageProps = Omit<CmsListWithImage, '_key' | '_type'>;

export const ListWithImage: React.VFC<ListWithImageProps> = ({
	list,
	heading,
	image,
	imageStyle = 'default',
	imagePosition = {
		mobile: 'bottom',
		desktop: 'right',
	},
	backgroundColor,
	textColor,
}) => {
	const customProperties = {
		'--list-with-image-color': textColor?.hex,
		'--list-with-image-background-color': backgroundColor?.hex,
	} as React.CSSProperties;

	return (
		<section
			className={classNames(
				styles.wrapper,
				styles[`image-style-${imageStyle}`],
				styles[`image-align-v-${imagePosition.mobile}`],
				styles[`image-align-h-${imagePosition.desktop}`]
			)}
			style={customProperties}
		>
			<div className={styles['list-wrapper']}>
				{heading ? (
					<h2 className={classNames('fluid-font-t2', styles.heading)}>
						{heading}
					</h2>
				) : null}
				<ul>
					{list.map(({ _key, title, paragraph, link }) => (
						<li className={styles['list-item']} key={_key}>
							<h3 className="fluid-font-t4-bold">{title}</h3>
							<p className={classNames('fluid-font-t5', styles.paragraph)}>
								{paragraph}
							</p>
							{link ? (
								<Link
									className={classNames('fluid-font-t6-bold', styles.link)}
									href={link.url}
								>
									<span>{link.text}</span>
									<Svg id="arrow-left" />
								</Link>
							) : null}
						</li>
					))}
				</ul>
			</div>
			<div>
				<SanityImage image={image} sizes={`${breakpoints.lg} 50vw, 100vw`} />
			</div>
		</section>
	);
};
